import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, message, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";


import {
  Image,
  Select,
  TimePicker,
  Upload,
} from "antd";
import bannerRequest from "./bannerRequest";
const initialFilter = { page: 1, limit: 10 };

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function CreateBanner() {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const navigate = useNavigate()
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [pathType, setPathType] = useState(''); // Store selected pathType
  const [pathIdOptions, setPathIdOptions] = useState([]); // Store fetched pathId options
  const [options, setOptions] = useState([]); // Options for select
 const [submited, setSubmit] = useState(false);
  const { Option } = Select;

  const fetchPathIdOptions = async (value) => {

    setLoading(true);
    try {
      const response = await bannerRequest.getPathIddetails(value); // Await the API call
      const result = response?.data?.data; // Assuming the data structure is { data: { data: [...] } }

      if (response.status === 200 && Array.isArray(result)) {
        // Update the options with correct data
        const options = result.map((item) =>
          value === "salon"
            ? { key: item.salonId, label: item.salonName, value: item.salonId }
            : { key: item.id, label: item.serviceName, value: item.id }
        );
        setPathIdOptions(options);
      } else {
        setPathIdOptions([]); // Clear options if response is invalid
        console.error("Failed to fetch pathId options:", result?.message || "Invalid response");
      }
    } catch (error) {
      console.error("Error fetching pathId options:", error);
      setPathIdOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // Handler for pathType change
  const handlePathTypeChange = (value) => {
    setPathType(value);
    if (value) {
      fetchPathIdOptions(value);
    } else {
      setPathIdOptions([]);
    }
  };

  const update=()=>{
    setSubmit(true);
  }

  const onFinish = (values) => {
    console.log(values)
    if(submited){
    setLoading(true);
    const allFormData = { ...values };
    console.log("allFormData", allFormData)
    bannerRequest.createBanner(allFormData)
      .then((res) => {
        console.log("API Response:", res);
        if (res.status === 201) {
          notification.success({
            message: "Banner added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add banner",
        });
        console.error("API Error:", e);
      });
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
    >
      <GrUpload />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    bannerRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          imageUrl: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {

      imageUpload(file, file.name);
      return false;
    },
    onRemove() {
      setFileList([]);
    },
  };

  return (
    <div>
      <section>
        <div className="Create-Category">
          <Form.Item className=" submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add Banner</h3>


          <Form
            layout="vertical"
            className="subscription-form"
            form={form}
            onFinish={onFinish}
          >
            <div className="subscription">
              <Form.Item
                label="Banner Name"
                name="title"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter banner name" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Banner name can only contain alphabetic characters!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter banner Name" />
              </Form.Item>
              <Form.Item
                label="Status"
                name="status"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select status" },
                ]}
              >
                <Select
                  placeholder="Select status"
                  // style={{
                  //   marginTop: "0.5rem",

                  //   width: "99%",
                  // }}
                  onChange={handleChange}
                  options={[
                    {
                      value: "0",
                      label: "Inactive",
                    },
                    {
                      value: "1",
                      label: "Active",
                    },

                  ]}
                />
              </Form.Item>
            </div>

            <div className="subscription">

              <Form.Item
                label="Order By"
                name="orderBy"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select order" },
                ]}
              >
                <Select
                  placeholder="Select order"
                  // style={{
                  //   marginTop: "0.5rem",

                  //   width: "99%",
                  // }}
                  onChange={handleChange}
                  options={[
                    {
                      value: "1",
                      label: "1",
                    },
                    {
                      value: "2",
                      label: "2",
                    },
                    {
                      value: "3",
                      label: "3",
                    },
                    {
                      value: "4",
                      label: "4",
                    },
                    {
                      value: "5",
                      label: "5",
                    },

                  ]}
                />
              </Form.Item>

              <Form.Item label="Path Type"
                name="pathType"
                className="subscription-plan"
                rules={[{ required: true, message: 'Please select a Path Type!' }]}>

                <Select placeholder="Select Path Type" onChange={handlePathTypeChange} allowClear>
                  <Option value="salon">Salon</Option>
                  <Option value="service">Service</Option>
                </Select>
              </Form.Item>

            </div>

            <div className="subscription">



              <Form.Item
                label="Path ID"
                name="pathId"
                className="subscription-plan"
                rules={[{ required: true, message: 'Please select a Path ID!' }]}>
                <Select
                  placeholder={loading ? 'Loading...' : 'Select Path ID'}
                  notFoundContent={loading ? 'Fetching options...' : 'No options available'}
                  allowClear
                  disabled={!pathType || loading}



                >
                  {pathIdOptions.map((option) => (
                    <Option key={option.key} value={option.value}>
                      {option.label} {option.value}
                    </Option>
                  ))}




                </Select>
              </Form.Item>

            </div>

            <div className="upload-Img">
              <Form.Item
                label="Upload Salon Images"
                name="imageUrl"

                rules={[
                  {
                    required: true,
                    message: "Please upload the salon images",
                  },
                ]}
              >
                <Upload
                  {...props} maxCount={1}
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleImageChange}
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                {previewImage && (
                  <Image
                    wrapperStyle={{
                      display: "none",
                    }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                  Save & Proceed
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>

          </Form>
        </div>
      </section>
    </div>
  )
}

export default CreateBanner